import { checkIsUserLoggedIn } from "../../../../utils/globalUtilities";
import { NO_IMAGE_SPEAKER, urlPrefix } from "../../../../constants/constants";
import "./offer-item-card.scss";
import { AppRouteURL } from "../../../../routes/app-route-urls";
import { ENDMILE_API_EVENT_LIST } from "../../constant/endmile/newEndMileAPI.event.list";
import { createNewEndmileAPITrackObject, postNewEndmileAPIEventTrack } from "@Src/services/eventTrack.service";
import { ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD } from "../../constant/endMileAPI.event.list";
import { LocalStorageDataModel } from "@Constants/local-storage-data-model";
interface OfferItemCardProps {
    itemsList: any
    showReadMore: boolean
    isVideos?: boolean
    showprice?: boolean,
    customIndex: any
}

export const OfferItemCard = ({ itemsList, showReadMore, isVideos, showprice ,customIndex}: OfferItemCardProps) => {
    const addPlatformQueryParam = (url: string) => {
        const platformQuery = 'platform=premium';
        if (url.includes('?')) {
            return `${url}&${platformQuery}`; 
        } else {
            return `${url}?${platformQuery}`; 
        }
    };

    function getAllSpeakerNames(speaker: any) {
        return speaker && speaker?.length &&
            speaker?.map((speak: any, index: number) => {
                const isLastSpeaker = index === speaker.length - 1;
                return isLastSpeaker ? speak.name : speak.name + ", ";
            }).join(' ');
    }

    const getFirstTwoSpeakerNames = (speakersList:any) => {
        if (!speakersList || speakersList.length === 0) return '';
        
        if (speakersList.length === 1) {
            return speakersList[0].name.trim();
        }
        
        return `${speakersList[0].name.trim()}, ${speakersList[1].name.trim()}`;
    }

    const isLoggedIn = checkIsUserLoggedIn();
    const linkHref = isLoggedIn
      ? addPlatformQueryParam(itemsList?.url)
      : `${urlPrefix}/${AppRouteURL.LOGIN}`;
    
   const onClickWebinarCTA = async () => {
  const endMileUserData = localStorage.getItem(LocalStorageDataModel.ENDMILE_USER_DATA) || "[]";
  let fieldsData =  [...JSON.parse(endMileUserData)];

  const getValue = (fieldId: string) => {
    const found = fieldsData?.find((item: any) => item.fieldid === fieldId);
    return found?.value || "";
  };

  let newTrackData: any = {
    'FIRST_NAME_LAST_NAME': getValue(ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.FIRST_NAME_LAST_NAME),
  };

  let payload = await createNewEndmileAPITrackObject(
    ENDMILE_API_EVENT_LIST.PREMIUM_EVENT_VIEWED,
    newTrackData,
    '',
    ENDMILE_API_EVENT_LIST.PREMIUM
  );
   postNewEndmileAPIEventTrack(payload);

   }

    return (
        <>
           <a
  href={linkHref}
  target={isLoggedIn ? '_blank' : '_self'}
  rel={isLoggedIn ? 'noopener noreferrer' : undefined}
  className={`case_law ${
    isVideos ? `learning_cards videos_card${customIndex % 4}` : 'isnotvides'
  }`}
  key={itemsList?.Id}
  onClick={()=> onClickWebinarCTA()}
>
                <span className="learning-card-images"> 
                {isVideos &&
                    <div className={`p-v-group-name ${itemsList?.is_live ? 'live_webinar_tag' : ''}`} >{itemsList?.is_live ? 'Live ' + itemsList?.groupName : itemsList?.groupName}</div>
                }
                <span className="card-imgs"> <img className="image1" alt={itemsList.heading} src={itemsList?.image_url} onError={(e) => {
                                    e.currentTarget.src = 'https://cdn.taxmann.com/taxmann-images/learning/empty-noimages-002.png';
                                }} /> </span>
                </span>
                <div className="learning-card-content">
                {isVideos ? <>
                    
                        <div className="learning-card-details">
                            {itemsList?.speakers_List ?
                            // <div className="p-v-speaker-img">
                            //     <div className="p-v-spk-span">
                            //         {itemsList?.speakers_List?.map((speaker: any, speakerIndex:number) => {
                            //             return (
                            //                 <img key={`Speaker${speakerIndex}`} src={speaker?.image_url} onError={({ currentTarget }) => {
                            //                     currentTarget.onerror = null; // prevents looping
                            //                     currentTarget.src = NO_IMAGE_SPEAKER;}} />
                            //             )
                            //         })}
                            //     </div>
                            // </div>
                            <span></span>
                            :
                            ''
                            }
                            {itemsList?.heading && (
                                <h4 className="law_list_video_title_1 text-elipsis l2">
                                    {itemsList.heading}
                                </h4>
                            )}
                            {/* {itemsList?.heading ?
                             <h6 className='law_list_video_title_1 text-elipsis l2'>{itemsList?.heading}</h6>
                            :
                            <h6 className='law_list_video_title_1 text-elipsis l2'>{itemsList?.heading}</h6>
                            } */}
                          <p className='law_list_authors'>
                                {itemsList?.speakers_List?.length > 0 && <span className="learning-author-names">by {getFirstTwoSpeakerNames(itemsList?.speakers_List)}</span>}
                                {itemsList?.speakers_List?.length - 2 > 0 && <span className="row-flex-text-1"> <span className="learning-author-names" title={getAllSpeakerNames(itemsList?.speakers_List)}> & {itemsList?.speakers_List?.length - 2}</span> <span className="view-more-1">more </span> </span>}
                            </p>
                            <p className='law_list_authors mt-3'>{itemsList?.event_date}</p>
                        </div>

                        <button className="Btn readmorehover btn_watched active ">

                        View Details  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.61943 12.5467C9.49276 12.5467 9.36609 12.5001 9.26609 12.4001C9.07276 12.2067 9.07276 11.8867 9.26609 11.6934L12.9594 8.00008L9.26609 4.30674C9.07276 4.11341 9.07276 3.79341 9.26609 3.60008C9.45943 3.40674 9.77943 3.40674 9.97276 3.60008L14.0194 7.64674C14.2128 7.84008 14.2128 8.16008 14.0194 8.35341L9.97276 12.4001C9.87276 12.5001 9.74609 12.5467 9.61943 12.5467Z" fill="#ED1C24"/>
<path d="M13.554 8.5H2.33398C2.06065 8.5 1.83398 8.27333 1.83398 8C1.83398 7.72667 2.06065 7.5 2.33398 7.5H13.554C13.8273 7.5 14.054 7.72667 14.054 8C14.054 8.27333 13.8273 8.5 13.554 8.5Z" fill="#ED1C24"/>
</svg>


                   
                </button>
                         {/* <button className="Btn HHHHHH">
                    <div className="sign">
                        <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.750122" width="39" height="39" rx="7.5" stroke="#646B84" />
                            <path d="M22.4299 14.1802L28.4999 20.2502L22.4299 26.3202" stroke="#646B84" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.5 20.2501H28.33" stroke="#646B84" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>


                    </div>
                    <div className="text">Watch Now &nbsp; <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.4299 6.18018L20.4999 12.2502L14.4299 18.3202" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M3.5 12.2501H20.33" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    </div>
                </button> */}
                    



                </> :
                    <div className="learning-card-details">
                        {
                        itemsList?.heading && itemsList?.sld ?
                        <h4 className='law_list_head list_height' >{itemsList?.sld} </h4>
                        :
                        ""
                        }
                           
                        {
                        itemsList?.categoryName ?
                        itemsList?.categoryName && itemsList?.groupName?
                        <p className='law_list_para KKK'>{itemsList?.categoryName} | {itemsList?.groupName} | {itemsList?.date}</p>
                           :
                         <h6 className='law_list_subhead RRRRR'>{itemsList?.categoryName} | {itemsList?.date}</h6>
                    :''
                    }
                        {itemsList?.globaltopic && itemsList?.heading !== itemsList?.globaltopic && (
                        <h4 className='law_list_subhead'>{itemsList?.heading}</h4>
                        )}
                        {
                            itemsList?.category ?
                            <p className='law_list_para'>{itemsList?.category} | {itemsList?.groupName}  | {itemsList?.date}</p>
                               :
                               ''
                    }
                    </div>
                }
                {showReadMore && <button className="Btn readmorehover">

                    Read More  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.61943 12.5467C9.49276 12.5467 9.36609 12.5001 9.26609 12.4001C9.07276 12.2067 9.07276 11.8867 9.26609 11.6934L12.9594 8.00008L9.26609 4.30674C9.07276 4.11341 9.07276 3.79341 9.26609 3.60008C9.45943 3.40674 9.77943 3.40674 9.97276 3.60008L14.0194 7.64674C14.2128 7.84008 14.2128 8.16008 14.0194 8.35341L9.97276 12.4001C9.87276 12.5001 9.74609 12.5467 9.61943 12.5467Z" fill="#ED1C24"/>
<path d="M13.554 8.5H2.33398C2.06065 8.5 1.83398 8.27333 1.83398 8C1.83398 7.72667 2.06065 7.5 2.33398 7.5H13.554C13.8273 7.5 14.054 7.72667 14.054 8C14.054 8.27333 13.8273 8.5 13.554 8.5Z" fill="#ED1C24"/>
</svg>


                    {/* <div className="sign">
                        <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.750122" width="39" height="39" rx="7.5" stroke="#646B84" />
                            <path d="M22.4299 14.1802L28.4999 20.2502L22.4299 26.3202" stroke="#646B84" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.5 20.2501H28.33" stroke="#646B84" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>


                    </div>
                    <div className="text">Read More &nbsp; <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.4299 6.18018L20.4999 12.2502L14.4299 18.3202" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M3.5 12.2501H20.33" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    </div> */}
                </button>}
</div>

            </a>

           

        </>
    )
}